export default __webpack_public_path__ + "786a5585e10da61380cdc245c92f8568.svg";